import React, { useState } from "react";
import { Col, ListGroup, Row } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";


/**
 * 
 * @param {props} closed bool if list should be open or closed
 * @param {props} title string of list title
 * @param {props} tickets array of ticket objects to be displayed in list
 * @param {props} selectedTicket ticket object which is selected
 * @param {props} setSelectedTicket setter object to change selected ticket
 * 
 * @returns 
 */
const TickList = (props) => {
    const [isOpen, setIsOpen] = useState(props.closed? false : true);

    return (
        <div className="text-center mb-5" style={{marginRight: 10}}>
            <a href={`/${props.title}/`} onClick={e => {e.preventDefault(); setIsOpen(!isOpen)}} style={{ textDecoration: "none"}} className="text-secondary">
                {props.title} {isOpen? <FaChevronUp /> : <FaChevronDown />}
            </a>

            <ListGroup variant="flush" hidden={!isOpen}>
                {props.tickets && props.tickets.length > 0 ?
                    props.tickets.map(ticket => (
                        <ListGroup.Item key={ticket.id}
                            action
                            onClick={() => props.setSelectedTicket(ticket)}
                        >
                            <Row className="align-items-center text-start">
                                <Col xs="10">
                                    <span style={props.selectedTicket !== undefined && props.selectedTicket.id === ticket.id ? { fontWeight: "800" } : null}>{ticket.name} (#{ticket.id})</span>
                                </Col>
                                <Col xs="2">
                                    {ticket.stage_id[1] === "Warten auf Kunde"? <span className="dot pulse"></span> : null}
                                </Col>
                            </Row>

                        </ListGroup.Item>
                    ))
                :
                    <ListGroup.Item>
                        <small>Keine Tickets</small>
                    </ListGroup.Item>
                }
            </ListGroup>
        </div>
    )
}

export default TickList;